import Transform from "./_transform";
import Scroll from "./_scroll";
import Animation from "./_animation";

export default class Mv {
    constructor() {
        this.$mv = document.getElementById("mv");
        this.$logo = this.$mv.querySelector(".mv__logo");
        this.$catch = this.$mv.querySelector(".mv__catch");
        this.$catches = this.$mv.querySelectorAll(".mv__catch");

        this.device = MAIN.isNarrow ? "sp" : "pc";

        this.transform = new Transform(this);
        this.scroll = new Scroll(this);

        this._init();
    }

    _init() {
        this.animation();
    }

    animation() {
        // `-pc`と`-sp`の各グループを別々に管理
        const $pcCatch = this.$mv.querySelector(".mv__catch.-pc");
        const $spCatch = this.$mv.querySelector(".mv__catch.-sp");

        // `-pc`と`-sp`の`data-pos`要素をそれぞれ取得し、並び替える
        const pcPosArr = $pcCatch ? [...$pcCatch.children] : [];
        const spPosArr = $spCatch ? [...$spCatch.children] : [];

        this.pcAnimation = new Animation($pcCatch, pcPosArr);
        this.spAnimation = new Animation($spCatch, spPosArr);
    }
}
